import React from 'react'
import styled from '@emotion/styled'
import { mediaQueries } from '../../theme'
import { withAttrs, chunkArray } from '../../utils'
import useMatchMedia from '../../hooks/use-media'
import { Slides, useCarousel } from '../shared/carousel'
import BaseNavigation from '../shared/carousel-navigation'
import Link from '../shared/link'
import PostList from './post-list'

const Container = styled.div`
  overflow: hidden;
`

const TitleLink = styled(withAttrs(Link, { variant: 'nav' }))`
  margin: 0;
  font-weight: ${p => p.theme.fontWeights.heading};
  font-size: ${p => p.theme.fontSizes[6]};
  line-height: 1.5;

  ${mediaQueries.lg} {
    font-size: ${p => p.theme.fontSizes[7]};
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${p => `0 ${p.theme.space[6]} ${p.theme.space[6]}`};
  ${mediaQueries.md} {
    margin: ${p => `0 0 ${p.theme.space[8]}`};
  }
`

const CategorySlides = styled(Slides)`
  padding: ${p => `0 ${p.theme.space[6]}`};
  ${mediaQueries.md} {
    padding: 0;
  }
`

const PostListContainer = styled.div`
  flex-shrink: 0;
  width: 87%;
  margin: ${p => `0 ${p.theme.space[4]} ${p.theme.space[11]} 0`};
  ${mediaQueries.md} {
    width: 100%;
    padding: ${p => `0 ${p.theme.space[1]} 0 0`};
    margin-bottom: ${p => p.theme.space[8]};
  }
`

const CategorySlide = ({ posts, className }) => (
  <PostListContainer className={className}>
    <PostList posts={posts} />
  </PostListContainer>
)

const Navigation = styled(BaseNavigation)`
  display: none;
  ${mediaQueries.md} {
    display: flex;
  }
`

const Category = ({ posts, className }) => {
  const {
    frontmatter: { category },
    fields: { categorySlug },
  } = posts[0]
  const { slidesRef, canScrollPrev, canScrollNext, scrollPrev, scrollNext } =
    useCarousel(categorySlug, {
      desktop: {
        draggable: false,
      },
    })
  const isMobile = !useMatchMedia(mediaQueries.md)

  const navigationProps = {
    canScrollPrev,
    canScrollNext,
    onScrollToPrev: scrollPrev,
    onScrollToNext: scrollNext,
  }

  const chunkedPosts = chunkArray(posts, isMobile ? 1 : 3)

  return (
    <Container className={className}>
      <Header>
        <TitleLink to={categorySlug}>{category}</TitleLink>
        <Navigation {...navigationProps} />
      </Header>

      <CategorySlides ref={slidesRef}>
        {chunkedPosts.map((chunk, index) => (
          <CategorySlide key={index} posts={chunk} />
        ))}
      </CategorySlides>
    </Container>
  )
}

export default Category
